import { render, staticRenderFns } from "./ActionComponent.vue?vue&type=template&id=35d05df2&scoped=true"
import script from "./ActionComponent.vue?vue&type=script&lang=js"
export * from "./ActionComponent.vue?vue&type=script&lang=js"
import style0 from "./ActionComponent.vue?vue&type=style&index=0&id=35d05df2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d05df2",
  null
  
)

export default component.exports